const OneTrust = () => {
  // Hide Cookie Settings menu if it is "Cookie Settings" ( The text becomes to "Cookie Settings" on Global IP)
  // Keep checking the text up to 6 seconds
  let cookieMenuTimeCount = 0;
  const checkCookieSettingMenu = setInterval( updateCookieSettingMenu, 300);
  function updateCookieSettingMenu(){
    const $cookieSettingMenu = document.querySelector(".ot-sdk-show-settings");
    if( $cookieSettingMenu.firstChild.nodeValue.includes("Cookie") ){
      $cookieSettingMenu.style.display = "none";
    } else{
      $cookieSettingMenu.style.display = "inline-block";
    }
    cookieMenuTimeCount++;
    if( cookieMenuTimeCount > 20 ){
      clearInterval(checkCookieSettingMenu);
    }
  }
}
export default OneTrust;